export default {
    Normal: {
        value: '1',
        label: 'Normal'
    },
    Suspend: {
        value: '2',
        label: 'Suspend'
    },
    Blacklist: {
        value: '3',
        label: 'Suspend with Alarm'
    },
    Special_Event_1: {
        value: '4',
        label: 'Special Event 1'
    },
    Special_Event_2: {
        value: '5',
        label: 'Special Event 2'
    },
    Scheduled_Tour: {
        value: '7',
        label: 'Scheduled Tour'
    },
    Access_Override: {
        value: '8',
        label: 'Access Override'
    },
    OssSo: {
        value: '9',
        label: 'Offline Enabled'
    }
};